/**
 * base3.xiaojukeji.com/docs/passport/开发指南/PC-passport接入.html
 * base3.xiaojukeji.com/docs/passport/概览/术语.html
 */
import qs from 'qs';
import config from '../config/passport';
import UrlHandler from './urlHandler';
import { getLocale } from './locale';
import UrlHashHandler from '@/utils/urlHashHandle';
import { isH5 } from '@/utils/tools';

const TYPES = {
  LOGIN: 'login',
  LOGOUT: 'logout',
};
class Passport {
  constructor({
    passportUrl,
    setCookieUrl,
    appId,
    role,
    source,
    country_id,
    lang,
    theme,
  }) {
    this.config = {
      passportUrl,
      setCookieUrl,
      appId,
      role,
      source,
      country_id,
      lang,
      theme,
    };
  }

  getHref(targetUrl, redirectUrl) {
    let {
      passportUrl,
      appId,
      setCookieUrl,
      role,
      source,
      country_id,
      lang,
      theme,
    } = this.config;

    let currentHref = targetUrl;
    redirectUrl = redirectUrl || encodeURI(decodeURI(currentHref));
    let setCookieUrlQuery = qs.stringify({
      redirectUrl,
    });

    let passportUrlQuery = qs.stringify({
      appid: appId,
      role,
      source,
      country_id: country_id,
      redirectUrl: encodeURI(decodeURI(setCookieUrl + '?' + setCookieUrlQuery)),
      lang,
      theme,
    });

    return passportUrl + '?' + passportUrlQuery;
  }

  // 登录成功地址
  get currentHref() {
    let urlHashHandler = new UrlHashHandler(location.href);
    urlHashHandler.set(TYPES.LOGIN);
    let loginHref = urlHashHandler.getUrl();
    return this.getHref(loginHref);
  }
  //
  get loginHref() {
    let urlHashHandler = new UrlHashHandler(location.href);
    urlHashHandler.set(TYPES.LOGIN);
    let loginHref = urlHashHandler.getUrl();
    return this.getHref(loginHref);
  }
  // TODO 登出的地址
  get logoutHref() {
    let homeHref = this._homeHref;
    let urlHashHandler = new UrlHashHandler(homeHref);
    urlHashHandler.set(TYPES.LOGOUT);
    let logoutHref = urlHashHandler.getUrl();
    // const loginHref = encodeURI(decodeURI(this.loginHref));
    return this.getHref(logoutHref);
  }

  get _homeHref() {
    let urlHandler = new UrlHandler(location.href);
    //去掉默认回到home逻辑
    if (isH5) {
      const targetPath = `${getLocale()}/entrega-business/home`;
      urlHandler.set({ pathname: targetPath });
    }

    return urlHandler.getUrl();
  }

  login() {
    location.href = this.loginHref;
  }

  logout() {
    // example:
    // const redirectUrl = 'http://sim291.rlab.sim.intra.xiaojukeji.com/c-api/login/callback?redirectUrl=https%253A%252F%252Fpage.didiglobal.com%252Fpublic-biz%252Fpc-login%252F3.1.0%252Findex.html%253Fappid%253D200044%2526role%253D1%2526source%253D70001%2526country_id%253D484%2526redirectUrl%253Dhttp%253A%252F%252Fsim291.rlab.sim.intra.xiaojukeji.com%252Fc-api%252Flogin%252Fcallback%253FredirectUrl%253Dhttp%2525253A%2525252F%2525252Flocalhost%2525253A8080%2525252Fes-MX%2525252Fentrega-business%2525252Faccount%25252523_callbackType%2525253Dlogin%2526lang%253Des-MX'
    // const href = `https://passport.didichuxing.com/common/pc-login/3.0.3/index.html?appid=xx&role=xx&source=xx&redirectUrl=${encodeURI(decodeURI(redirectUrl))}#/logout`
    location.href = this.logoutHref + '#/logout';
  }

  register() {
    location.href = this.currentHref + '#/register';
  }

  forget() {
    location.href = this.currentHref + '#/forget';
  }
}

export default new Passport(config.passport);
